import { render } from "./ChangePasswordDialog.vue?vue&type=template&id=99c56630"
import script from "./change-password-dialog-component.ts?vue&type=script&lang=js&external"
export * from "./change-password-dialog-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__